import {
  Guest,
  ReceiveOptions,
} from '@/app/system/guest/Guest';
import { GuestAware } from '@/app/system/guest/GuestAware';
import { PatronPool } from '@/app/system/guest/PatronPool';

export class Value<T> implements Guest<T>, GuestAware<T> {
  private pool: PatronPool<T>;

  public constructor(private theValue: T, initiator: unknown) {
    this.pool = new PatronPool<T>(initiator);
  }

  introduction() {
    return 'guest' as const;
  }

  receive(value: T, options?: ReceiveOptions): this {
    this.theValue = value;
    this.pool.receive(value, options);
    return this;
  }

  receiving(guest: Guest<T>): this {
    guest.receive(this.theValue);
    this.pool.add(guest);
    return this;
  }
}
